import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import { TextInput } from "../components/TextInput";

export const EditOrganizationDialog = ({
  onClose,
  onSave,
  saveAvaliable,
  currentOrganization,
  name,
  onNameChange,
  nameNotUnique,
  reportLinkID,
  onReportLinkIDChange
}) => (
  <Dialog maxWidth="lg" scroll="body" onClose={onClose} open spacing={0}>
    <DialogTitle
      onCancel={onClose}
      onSave={onSave}
      saveAvaliable={saveAvaliable}
    >
      Organization: {currentOrganization.name}
    </DialogTitle>
    <DialogContent>
      <TextInput
        label={nameNotUnique ? "Organization already exists" : "Name"}
        value={name}
        onChange={onNameChange}
        required
        error={nameNotUnique}
      />
      <TextInput
        label="Dashboard Report Link ID"
        value={reportLinkID}
        onChange={onReportLinkIDChange}
      />
    </DialogContent>
  </Dialog>
);
